var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2107_6369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5656 0.704305C26.7662 -2.22522 38.278 4.26445 41.2789 15.1951C44.2799 26.1291 37.632 37.3667 26.4347 40.2963C15.234 43.2258 3.7223 36.7361 0.72132 25.8055C-2.27966 14.8715 4.36487 3.63383 15.5656 0.704305Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6475 10.7671C17.1172 10.7671 18.3066 12.4521 18.3066 14.5274C18.3066 16.6028 17.1172 18.2878 15.6475 18.2878C14.1777 18.2878 12.9883 16.6028 12.9883 14.5274C12.9883 12.4521 14.1777 10.7671 15.6475 10.7671ZM9.61133 31.5974C15.3159 24.3804 27.0464 24.5372 32.0947 31.6108L32.9185 30.8133C27.2651 21.4475 15.2954 21.1138 8.75342 30.7633L9.61133 31.5974ZM26.3525 10.7671C27.8223 10.7671 29.0117 12.4521 29.0117 14.5274C29.0117 16.6028 27.8223 18.2878 26.3525 18.2878C24.8828 18.2878 23.6934 16.6028 23.6934 14.5274C23.6899 12.4521 24.8828 10.7671 26.3525 10.7671Z",
    fill: "#141518"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2107_6369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 41,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.bb2bdb684c75f4eeb4a4f22ccbf1ee03.svg";
export { ForwardRef as ReactComponent };